import {CLEAR_ERRORS, SET_CONFIRM, SET_ERROR, SET_UNKNOWN_ERROR} from "../Actions/Types/errorActionTypes";

const initialState = {
    error: null,
    unknownError: false,
    confirm: null,
};

export const errorReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ERROR:
            return {
                ...state,
                error: action.error,
            };
        case SET_UNKNOWN_ERROR:
            return {
                ...state,
                unknownError: true,
                error: action.error,
            };
        case SET_CONFIRM:
            return {
                ...state,
                confirm: action.confirm,
            };
        case CLEAR_ERRORS:
            return initialState;
        default:
            return state;
    }
};


